import React from 'react';
import { Trail } from '../../../../models/Trail';
import {
	OutroTourLine,
	VTInnerImg,
	VTInnerImgContainer,
	VTIntroInner,
	VTOutroMeta,
} from '../virtualTourStyles';
import { checkImage } from '../../../componentUtils';

type OutroSlideProps = {
	trail: Trail;
};
const OutroSlide: React.FC<OutroSlideProps> = ({ trail }) => {
	return (
		<>
			<VTIntroInner>
				<VTInnerImgContainer>
					<VTInnerImg src={checkImage(trail.image)} />
				</VTInnerImgContainer>

				<h2>{trail.title}</h2>
				<VTOutroMeta>Trail complete</VTOutroMeta>
			</VTIntroInner>
			<OutroTourLine />
			{/* <ForwardArrow /> */}
		</>
	);
};

export default OutroSlide;
